import chunk from 'lodash/chunk'
import { isFunction } from 'helpers'

import { formatMessage } from 'locale.js'
import messages from './translations'
import { MESSAGE_PLAYERS_CHUNK } from './constants'

export const ROLE_ALREADY_ASSIGNED = 69
export const CANNOT_CHANGE_ROLE = 79
export const CANNOT_REMOVE_MEMBERS = 80
export const CANNOT_ALLOCATE_RESOURCE = 81
export const TOO_LONG_WAITING_TRANSACTION_STATUS = '_1'


const MAP_ERRORS = {
    // is local error codes
    [TOO_LONG_WAITING_TRANSACTION_STATUS]: 'too_long_waiting_transaction_status',

    // is equal to wgcg error codes
    3: 'insufficient_permissions',
    13: 'banned',
    29: 'excluded_from_clan',
    40: 'clan_in_transaction',
    50: 'change_commander_cooldown',
    53: 'no_gold',
    72: 'clan_in_transaction',
    [CANNOT_CHANGE_ROLE]: 'cannot_change_role',
    [CANNOT_REMOVE_MEMBERS]: 'cannot_remove_members',
    [CANNOT_ALLOCATE_RESOURCE]: 'cannot_allocate_resource',
    'default': 'default',
}

export const wrapInP = (...args) => (args.join('\n'))

export const getMemberName = (id, members) => members.find((member) => member.id === id).name

export const getMembersNames = (ids, members) => ids.map((id) => getMemberName(Number(id), members))

export const getErrorReason = (error = {}) => MAP_ERRORS[error.code] || MAP_ERRORS.default

export const getErrorMessage = (errors, reason, ...extra) => {
    const callbackOrMessage = errors[reason] || errors.default
    return isFunction(callbackOrMessage) ? callbackOrMessage(...extra) : callbackOrMessage
}

export const getErrorHeader = (...args) => getErrorMessage(...args)

export const processReponseReasonArray = (temp, tempLength, names, result, info, getMessage) => {
    if (tempLength) {
        const temporalChunkSlots = MESSAGE_PLAYERS_CHUNK() - tempLength
        const battleNamesToTemporalChunk = names.slice(0, temporalChunkSlots)
        temp.push(getMessage(battleNamesToTemporalChunk, info))
        tempLength += battleNamesToTemporalChunk.length
        if (tempLength === MESSAGE_PLAYERS_CHUNK()) {
            result.push(temp)
            temp = []
            tempLength = 0
        }
        names = names.slice(temporalChunkSlots)
    }

    chunk(names, MESSAGE_PLAYERS_CHUNK()).map((reasonBattlesNamesChunk) => {
        if (reasonBattlesNamesChunk.length < MESSAGE_PLAYERS_CHUNK()) {
            temp.push(getMessage(reasonBattlesNamesChunk, info))
            tempLength = reasonBattlesNamesChunk.length
        } else {
            result.push(getMessage(reasonBattlesNamesChunk, info))
        }
    })

    return { temp, tempLength }
}

export const getMessageBanned = (info) => {
    return info.banned_account_id === info.accountId ?
        formatMessage(messages.banned) :
        formatMessage(info.messages.banned, {
            name: formatPlayer(getMemberName(info.banned_account_id, info.members)),
        })
}

export const formatPlayer = (name) => (
    `<font color="#C9C9B6">${name}</font>`
)

export const BASE_ERRORS = {
    banned: getMessageBanned,
    excluded_from_clan: () => formatMessage(messages.excluded_from_clan),
    insufficient_permissions: () => formatMessage(messages.insufficient_permissions),
    clan_in_transaction: () => formatMessage(messages.clan_in_transaction),
    too_long_waiting_transaction_status: () => formatMessage(messages.too_long_waiting_transaction_status),
}

export const BASE_ERROR_HEADERS = {
    too_long_waiting_transaction_status: () => formatMessage(messages.too_long_waiting_transaction_status_header),
    'default': null,
}



// WEBPACK FOOTER //
// ./state/actions/CMT/Notifications/base.js